import { useEffect, useState } from 'react';
import { authApi } from '../../services/auth';

interface Props {
  phone: string;
  purpose: 'register' | 'login' | 'bind' | 'reset';
  disabled?: boolean;
  onError?: (msg: string) => void;
  onSent?: () => void;
}

const PHONE_RE = /^1[3-9]\d{9}$/;
const COUNTDOWN = 60;

export function SmsCodeButton({ phone, purpose, disabled, onError, onSent }: Props) {
  const [loading, setLoading] = useState(false);
  const [seconds, setSeconds] = useState(0);

  // 每次 seconds 变化时启动/停止倒计时；组件卸载自动清理。
  useEffect(() => {
    if (seconds <= 0) return;
    const id = setInterval(() => {
      setSeconds((s) => s - 1);
    }, 1000);
    return () => clearInterval(id);
  }, [seconds]);

  async function handleClick() {
    if (!PHONE_RE.test(phone)) {
      onError?.('请输入正确的手机号');
      return;
    }
    setLoading(true);
    try {
      await authApi.smsSend({ phone, purpose });
      onSent?.();
      setSeconds(COUNTDOWN);
    } catch (err: unknown) {
      const msg =
        (err as { response?: { data?: { message?: string } } })?.response?.data?.message ??
        '发送失败，请稍后重试';
      onError?.(msg);
    } finally {
      setLoading(false);
    }
  }

  const counting = seconds > 0;
  const isDisabled = disabled || loading || counting;

  let label: string;
  if (loading) label = '发送中';
  else if (counting) label = `${seconds} 秒`;
  else label = '获取验证码';

  return (
    <button
      type="button"
      disabled={isDisabled}
      onClick={handleClick}
      className="shrink-0 rounded border border-line px-3 py-2 text-sm text-navy hover:border-navy disabled:cursor-not-allowed disabled:text-fg-subtle disabled:opacity-50 max-lg:rounded-control"
    >
      {label}
    </button>
  );
}
